// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDEedg0aOKkp8JwiTMmWewlwAcDweMgyQs",
  authDomain: "badminton-smash.firebaseapp.com",
  projectId: "badminton-smash",
  storageBucket: "badminton-smash.appspot.com",
  messagingSenderId: "1015327331050",
  appId: "1:1015327331050:web:e1f3d79253a088eca47d93"
};

export enum FirebaseCollection {
  Players = "Players",
  Tokens = "Tokens"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default getFirestore(app);